var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEscalationSmall = function SvgIconEscalationSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.153 16.307a8.142 8.142 0 0 0 8.154-8.154A8.142 8.142 0 0 0 8.153 0 8.153 8.153 0 0 0 0 8.153a8.142 8.142 0 0 0 8.153 8.154z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#00918A",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.675,
    d: "M9.994 6.288a.498.498 0 0 0-.362-.14H5.54c-.643 0-.643 1.003 0 1.003h2.908l-5.844 5.843c-.893.886-1.316 1.336-1.268 1.35.163.047.3.496 1.268 0 .138-.071.506-.414 1.105-1.028L9.15 7.874v2.908c0 .643 1.004.643 1.004 0V6.63c0-.14-.06-.26-.16-.341z",
    mask: "url(#b)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEscalationSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-escalation-small.ad6707654e84bf91ea02f4751ba60d6b.svg";